"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayerContext = void 0;
exports.VideoPlayerProvider = VideoPlayerProvider;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VideoPlayerContext = exports.VideoPlayerContext = /*#__PURE__*/(0, _react.createContext)({
  playersInitialized: {},
  setPlayersInitialized: function setPlayersInitialized() {}
});
function VideoPlayerProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    playersInitialized = _useState2[0],
    setPlayersInitialized = _useState2[1];
  var playerContextValue = (0, _react.useMemo)(function () {
    return {
      playersInitialized: playersInitialized,
      setPlayersInitialized: setPlayersInitialized
    };
  }, [playersInitialized, setPlayersInitialized]);
  return /*#__PURE__*/_react["default"].createElement(VideoPlayerContext.Provider, {
    value: playerContextValue
  }, children);
}